import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Connect wallet',
    description: 'To access this page, please connect your wallet.',
    connect: 'Connect',
  },
};
